/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import PlanComponent from './main';
import EditPlanComponent from './edit/main';
import NewPlanComponent from './new/main';

export const plan = (context, next) => {
    context.primary = <PlanComponent />;
    next();
};

export const editPlan = (context, next) => {
    context.primary = <EditPlanComponent />;
    next();
};

export const newPlan = (context, next) => {
    context.primary = <NewPlanComponent />;
    next();
};